import { LOGOUT_REQUEST, LOGOUT_REQUEST_FAILURE, LOGOUT_REQUEST_SUCCESS } from '@sit/client-shared';
import * as types from './types';
import { FallbackMultiFactorAuthenticationModel, LoginAction } from './types';

export const getUserRequest = (data?: any) => ({ type: types.GET_USER_REQUEST, data });
export const getUserRequestFailure = (error?: any) => ({ type: types.GET_USER_REQUEST_FAILURE, error });
export const getUserRequestSuccess = (data?: any) => ({ type: types.GET_USER_REQUEST_SUCCESS, data });

export const loginRequest = (data: LoginAction) => ({ type: types.LOGIN_REQUEST, data });
export const loginRequestFailure = (error?: any) => ({ type: types.LOGIN_REQUEST_FAILURE, error });
export const loginRequestSuccess = (payload: any) => ({ type: types.LOGIN_REQUEST_SUCCESS, payload });

export const logoutRequest = (data?: any) => ({ type: LOGOUT_REQUEST, data });
export const logoutRequestFailure = (data?: any) => ({ type: LOGOUT_REQUEST_FAILURE, data });
export const logoutRequestSuccess = (data?: any) => ({ type: LOGOUT_REQUEST_SUCCESS, data });

export const registerResendEmailRequest = (data?: any) => ({ type: types.REGISTER_RESEND_EMAIL_REQUEST, data });
export const registerResendEmailRequestFailure = (error?: any) => ({ type: types.REGISTER_RESEND_EMAIL_REQUEST_FAILURE, error });
export const registerResendEmailRequestSuccess = (data?: any) => ({ type: types.REGISTER_RESEND_EMAIL_REQUEST_SUCCESS, data });

export const registerEmployeeRequest = (data?: any) => ({ type: types.REGISTER_EMPLOYEE_REQUEST, data });
export const registerEmployeeRequestFailure = (error?: any) => ({ type: types.REGISTER_EMPLOYEE_REQUEST_FAILURE, error });
export const registerEmployeeRequestSuccess = (payload: any) => ({ type: types.REGISTER_EMPLOYEE_REQUEST_SUCCESS, payload });

export const sendFallbackMfaCodeRequest = (data: FallbackMultiFactorAuthenticationModel) => ({
  type: types.SEND_FALLBACK_MFA_CODE_REQUEST,
  data,
});
export const sendFallbackMfaCodeRequestFailure = (error?: any) => ({ type: types.SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE, error });
export const sendFallbackMfaCodeRequestSuccess = (data?: any) => ({ type: types.SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS, data });

export const updateAccessToken = (data?: any) => ({ type: types.UPDATE_ACCESS_TOKEN, data });

export const updatePasswordRequest = (data?: any) => ({ type: types.UPDATE_PASSWORD_REQUEST, data });
export const updatePasswordRequestFailure = (error?: any) => ({ type: types.UPDATE_PASSWORD_REQUEST_FAILURE, error });
export const updatePasswordRequestSuccess = (data?: any) => ({ type: types.UPDATE_PASSWORD_REQUEST_SUCCESS, data });

export const updateUserRequest = (data?: any) => ({ type: types.UPDATE_USER_REQUEST, data });
export const updateUserRequestFailure = (error?: any) => ({ type: types.UPDATE_USER_REQUEST_FAILURE, error });
export const updateUserRequestSuccess = (data?: any) => ({ type: types.UPDATE_USER_REQUEST_SUCCESS, data });
